import { Action } from '@ngrx/store';
import { ICommunityGrant } from 'src/commons';

export enum CommunityGrantActionTypes {
  LoadCommunityGrantState = '[CommunityGrant] Load CommunityGrant State',
  LoadCommunityGrantStateSuccess = '[CommunityGrant] Load CommunityGrant State Success',
  LoadCommunityGrantStateFail = '[CommunityGrant] Load CommunityGrant State Fail',
  LoadInitialState = '[CommunityGrant] Load CommunityGrant Initial State',
  CommunityGrantScreenErrorReset = '[CommunityGrant] CommunityGrant Screen Error Reset'

}

export class LoadCommunityGrantState implements Action {
  readonly type = CommunityGrantActionTypes.LoadCommunityGrantState;
  constructor(public formId: Number) {}
}

export class LoadCommunityGrantStateSuccess implements Action {
  readonly type = CommunityGrantActionTypes.LoadCommunityGrantStateSuccess;
  constructor(public payload: ICommunityGrant ) {}
}

export class LoadCommunityGrantStateFail implements Action {
  readonly type = CommunityGrantActionTypes.LoadCommunityGrantStateFail;
  constructor(public payload: any) {}
}

export class CommunityGrantScreenErrorReset implements Action {
  readonly type = CommunityGrantActionTypes.CommunityGrantScreenErrorReset;
}

export class LoadInitialState implements Action {
  readonly type = CommunityGrantActionTypes.LoadInitialState;
}

export type CommunityGrantActions = 
  LoadCommunityGrantState
  | LoadCommunityGrantStateSuccess
  | LoadCommunityGrantStateFail
  | CommunityGrantScreenErrorReset
  | LoadInitialState;